// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormTruck } from '~/utils/interface/truck';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormTruck> => {
  return yup.object().shape({
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    status: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    truckType: yup.string().optional(),
    rentalStatus: yup.string().optional(),
    note: yup.string().optional(),
    numberOfSeats: yup.string().optional(),
    isPairingCapability: yup.boolean().optional(),
    trailerType: yup.array().optional(),
    linxupDeviceUuid: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesTruckForm: IFormTruck = {
  name: EMPTY_STRING,
  truckType: EMPTY_STRING,
  rentalStatus: EMPTY_STRING,
  status: EMPTY_STRING,
  numberOfSeats: EMPTY_STRING,
  note: EMPTY_STRING,
  linxupDeviceUuid: EMPTY_STRING,
  isPairingCapability: false,
  trailerType: [],
};
